<div class="side-popup" *ngIf="visible" @fadeInOut>
  <div
    class="card"
    [ngClass]="{
      'with-chips': getIsFilterFn,
      'with-role-toggle': isHrAndManager
    }"
    [@fadeContent]="selectedEmployee?.emp_id"
  >
    <div class="card-header d-flex justify-content-between align-items-center">
      <span *ngIf="mode === 'single'">
        Employee Details ({{ selectedEmployee?.name }})
      </span>
      <span *ngIf="mode === 'bulk'"> Bulk Submission </span>
      <button class="btn-close" (click)="onClose()"></button>
    </div>
    <div class="card-body">
      <!-- SINGLE EMPLOYEE VIEW -->
      <ng-container *ngIf="mode === 'single'">
        <div class="row">
          <div class="col-sm-12">
            <label class="LLabel">Total Available Leaves</label>
            <p class="LValue">{{ getTotalLeavesFn(selectedEmployee) }}</p>
          </div>
        </div>

        <div>
          <label class="LLabel">Project Code (Optional)</label><br />

          <ng-select
            [items]="projectCodeList"
            bindLabel="displayName"
            bindValue="id"
            [(ngModel)]="selectedEmployee.pay_adjustment.project"
            [ngModelOptions]="{ standalone: true }"
            placeholder="Select Project Code"
            [searchable]="true"
            [clearable]="true"
            class="filter-select"
            [disabled]="isFormDisabled"
            [searchFn]="customSearchFn"
            (search)="onProjectSearch($event?.term)"
            (clear)="onProjectClear()" 
            (change)="onProjectChange($event)"
          ></ng-select>

          <div *ngIf="isOtherSelected" class="mt-2">
            <input
              type="text"
              class="form-control project-input"
              [disabled]="isFormDisabled"
              placeholder="Enter project code or name manually"
              [(ngModel)]="selectedEmployee.pay_adjustment.unlisted_project"
              [ngModelOptions]="{ standalone: true }"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <label class="LLabel"
              >Casual Leave
              <span class="edit-lock"
                >&nbsp;<img src="assets/images/edit-lock.svg" alt="" /></span
            ></label>
            <p class="LValue">{{ selectedEmployee?.casual_leave }}</p>
          </div>
          <div class="col-sm-6">
            <label class="LLabel"
              >Earned Leave
              <span class="edit-lock"
                >&nbsp;<img src="assets/images/edit-lock.svg" alt="" /></span
            ></label>
            <p class="LValue">{{ selectedEmployee?.earned_leave }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <label class="LLabel"
              >Sick Leave
              <span class="edit-lock"
                >&nbsp;<img src="assets/images/edit-lock.svg" alt="" /></span
            ></label>
            <p class="LValue">{{ selectedEmployee?.sick_leave }}</p>
          </div>
          <div class="col-sm-6">
            <label class="LLabel">LOP</label>
            <input
              type="number"
              placeholder="Loss Of Pay"
              class="lop no-spinner"
              id="lops"
              (ngModelChange)="onLopChange($event)"
              [(ngModel)]="selectedEmployee.pay_adjustment.loss_of_pay_days"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="isFormDisabled"
              min="0"
              max="totalWorkingDays"
              appOnlyNumbers
            />
            <div
              *ngIf="isLopInvalid"
              class="text-danger mt-1"
              style="font-size: 0.8vw"
            >
              LOP cannot be more than {{totalWorkingDays}} days
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <label class="LLabel"
              >Payable Days
              <span class="cgen fgen"
                >(Working Days - Loss Of Pay)
                <span class="edit-lock"
                  >&nbsp;<img
                    src="assets/images/edit-lock.svg"
                    alt="" /></span></span
            ></label>
            <p class="LValue">
              {{
                selectedEmployee.pay_adjustment.payable_days !== null &&
                selectedEmployee.pay_adjustment.payable_days !== undefined
                  ? selectedEmployee.pay_adjustment.payable_days
                  : totalWorkingDays
              }}
            </p>
          </div>
        </div>

        <div>
          <label class="LLabel">Fixed Reimbursement</label><br />
          <ng-select
            [items]="fixedReimburses"
            bindLabel="amount"
            bindValue="id"
            [(ngModel)]="selectedEmployee.pay_adjustment.fixed_reimbursement"
            [ngModelOptions]="{ standalone: true }"
            placeholder="Fixed Reimbursement"
            [searchable]="true"
            [clearable]="true"
            class="filter-select"
            [disabled]="isFormDisabled"
          ></ng-select>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <label class="LLabel">Deductions (In Rupees)</label>
            <input
              type="number"
              class="no-spinner"
              placeholder="Enter deduction amount"
              [(ngModel)]="selectedEmployee.pay_adjustment.deduction"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="isFormDisabled"
              appOnlyNumbers
            />
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <label class="LLabel">Additional Remarks (Optional)</label>
            <textarea
              placeholder="Remarks (optional)"
              [(ngModel)]="selectedEmployee.pay_adjustment.remarks"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="isFormDisabled"
            ></textarea>
          </div>
        </div>
      </ng-container>

      <!-- BULK SUBMISSION VIEW -->
      <ng-container *ngIf="mode === 'bulk'">
        <div class="alert alert-bulk-info text-center d-flex gap-2">
          <img src="/assets/images/report.svg" alt="" />
          {{ selectedEmployees?.length || 0 }} out of
          {{ totalemployees?.length || 0 }} selected
        </div>

        <div>
          <label class="LLabel"
            >Project Code
            <span class="lmessage"
              >(Project code will apply uniformly to all selected
              employees.)</span
            ></label
          ><br />
          <ng-select
            [items]="projectCodeList"
            bindLabel="displayName"
            bindValue="id"
            [(ngModel)]="projectCode"
            [ngModelOptions]="{ standalone: true }"
            placeholder="Select Project Code"
            [searchable]="true"
            [clearable]="true"
            class="filter-select"
            [disabled]="isFormDisabled"
            [searchFn]="customSearchFn"
            (search)="onProjectSearch($event?.term)"
            (change)="onProjectChange($event)"
            (clear)="onProjectClear()" 
          ></ng-select>

          <div *ngIf="isOtherSelected" class="mt-2">
            <input
              type="text"
              class="form-control  project-input"
              [disabled]="isFormDisabled"
              placeholder="Enter project code or name manually"
              [(ngModel)]="unlistedProject"
              [ngModelOptions]="{ standalone: true }"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <label class="LLabel"
              >Additional Remarks
              <span class="lmessage"
                >(Additional remarks will apply uniformly to all selected
                employees.)</span
              ></label
            >
            <textarea
              placeholder="Remarks (required)"
              [(ngModel)]="remarks"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="isFormDisabled"
              required
              #remarksCtrl="ngModel"
              class="form-control"
            ></textarea>
            <div
              *ngIf="
                remarksCtrl.invalid &&
                (remarksCtrl.dirty || remarksCtrl.touched)
              "
              class="text-danger mt-1"
              style="font-size: 0.8vw"
            >
              Remarks are required.
            </div>
          </div>
        </div>
      </ng-container>
      <!-- Table for bulk -->
      <div *ngIf="mode === 'bulk'" class="table-responsive inner-table mt-2">
        <table class="table table-bordered">
          <thead class="table-light-head">
            <tr>
              <th>Temp Code</th>
              <th>Name</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let emp of selectedEmployees">
              <td>{{ emp.emp_id }}</td>
              <td>{{ emp.name }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="card-footer d-flex justify-content-end gap-2">
      <button type="button" class="btn cancel-btn" (click)="onClose()">
        Cancel
      </button>
      <button
        type="button"
        class="btn submit-btn"
        (click)="onSubmit()"
        *ngIf="!isFormDisabled"
        [disabled]="
          isFormDisabled ||
          isLopInvalid ||
          (mode === 'bulk' && (!remarks || remarks.trim() === ''))
        "
      >
        Submit
      </button>
    </div>
  </div>
</div>
